<template>
<div :style="scaleStyle"
     ref="previewMain"
     :class="{'is-sample': isSample, 'is-preview': !isSample}"
     >
  <div class="doc-paper preview rirekisho"
       :id="idPrefix + 'preview-page-01'">
    <div class="flex">
      <div class="rirekisho-box1">
        <div class="rirekisho-header">
          <div class="title">이력서</div>
          <div class="date"
               @click="goCardTo('create-date')"
               :class="highLightClass('create-date')">
            <span v-html="formatedCreateDate"></span> 현재
          </div>
        </div>
        <div class="rirekisho-profile"
             :data-highlight="highlightMessage"
             @click="goCardTo('profile')"
             :class="highLightClass('profile')">

          <div class="name flex" style="border-top: dotted 0px #000;height:100px;">
            <div class="label">성명</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.lastName }}&emsp;{{ basicData.firstName }}</div>
          </div>
          <div class="etc flex">
            <div class="birthday" :style="formatData.selFontStyle">
              <span class="year">{{ basicData.birthYear }}</span>년 <span class="month">{{ basicData.birthMonth }}</span>월 <span class="day">{{ basicData.birthDay }}</span>일（만 <span class="age">{{ age }}</span> 세）
            </div>

            <div class="gender">
              <span class="male" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isMale}">남</span><span v-if="!isGenderDisplay">・</span>
              <span class="female" v-if="!isGenderDisplay"
                    v-bind:class="{'preview-is-checked': isFemale}">여</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rirekisho-photo"
           :data-highlight="highlightMessage"
           @click="goCardTo('id-photo')"
           :class="highLightClass('id-photo')">
        <div v-if="basicData.idPhotoSrc">
          <img :src="basicData.idPhotoSrc"
               alt="증명사진">
        </div>
        <div v-else>
          <div class="rirekisho-photo-inner">
            <p>증명사진
              <br>세로 36mm&#12316;40mm
              <br>가로 24mm&#12316;30mm
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-box2">
      <div class="contact-information contact-main flex">
        <div class="contact-information-address"
             :data-highlight="highlightMessage"
             @click="goCardTo('address')"
             :class="highLightClass('address')">

          <div class="address flex" style="border-top: dotted 0px #000;">
            <div class="label">주소</div>
            <div class="input">
              <div class="postal-code" :style="formatData.selFontStyle">{{ $formLib.separatedPostNumber(basicData.postNumber) }}</div>
              <pre :style="formatData.selFontStyle">{{ basicData.address1}}
{{ basicData.address2 }}</pre>
            </div>
          </div>
        </div>
        <div class="contact-information-etc"
             :data-highlight="highlightMessage"
             @click="goCardTo('contacts')"
             :class="highLightClass('contacts')">
          <div class="tel flex">
            <div class="label">전화</div>
            <div class="input" :style="formatData.selFontStyle">{{ tel }}</div>
          </div>
          <div class="email flex">
            <div class="label">Email</div>
            <div class="input" :style="formatData.selFontStyle">{{ basicData.email }}</div>
          </div>
        </div>
      </div>
      <div class="contact-information contact-sub flex">
        <div class="contact-information-address"
             @click="goCardTo('address')"
             :class="highLightClass('address')">

<!--          <div class="address flex">-->
<!--            <div class="label">연락처</div>-->
<!--            <div class="input">-->
<!--              <div class="postal-code" :style="formatData.selFontStyle">{{ $formLib.separatedPostNumber(basicData.contactPostNumber) }}</div>-->
<!--              <div class="comment">(현주소 이외에 연락을 원하는 경우에만 입력)</div>-->
<!--              <pre :style="formatData.selFontStyle">{{ basicData.contactAddress1 }}-->
<!--{{ basicData.contactAddress2 }}</pre>-->
<!--              <div class="care-of"-->
<!--                   v-if="basicData.contactCareOf" :style="formatData.selFontStyle">{{ basicData.contactCareOf }} 方</div>-->
<!--            </div>-->
<!--          </div>-->
        </div>

      </div>
    </div>
    <div class="rirekisho-table rirekisho-history-1"
         :data-highlight="highlightMessage"
         @click="goCardTo('edu-history')"
         :class="highLightClass(['edu-history','job-history'])">
      <table :class="{error:this.errorMessages.eduJobHistory}">
        <thead>
          <tr>
            <th>년</th>
            <td>월</td>
            <td>학력・경력</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in eduJobHistoryTable"
              v-bind:class="item.classObject"
              v-if="index < 19"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="doc-paper preview rirekisho"
       :id="idPrefix + 'preview-page-02'">
    <div class="rirekisho-table rirekisho-skill"
         :data-highlight="highlightMessage"
         @click="goCardTo('license-history')"
         :class="highLightClass('license-history')">
      <table :class="{error:this.errorMessages.licenseHistory}">
        <thead>
          <tr>
            <th>년</th>
            <td>월</td>
            <td>면허・자격증</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in licenseHistoryTable"
              v-bind:class="item.classObject"
              v-if="index < 10"
              :key="index">
            <th :style="formatData.selFontStyle">{{ item.year }}</th>
            <td :style="formatData.selFontStyle">{{ item.month }}</td>
            <td :class="{'font-size-sm': ($formLib.charCount(item.description) > 68) }" :style="formatData.selFontStyle">{{ item.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="rirekisho-pr"  style="height:268px;">
      <div class="rirekisho-jis-pr-reason"
           v-if="formatId != 'rirekisho_job_change'"
           :data-highlight="highlightMessage"
           @click="goCardTo('reason')"
           :class="highLightClass('reason')"

      >
        <div class="label">지원동기, 특기, 어필포인트 등</div>
        <div class="input">
          <pre ref="reason"
               :class="classObject.reason" :style="formatData.selFontStyle">{{ formatData.reason }}</pre>
        </div>
      </div>
      <div class="rirekisho-jis-pr-reason"
            v-else
           :data-highlight="highlightMessage"
           @click="goCardTo('reason')"
           :class="highLightClass('reason')">
        <div class="label">지원동기, 특기, 어필포인트 등</div>
        <div class="input">
          <pre ref="reason"
               :class="classObject.reason" :style="formatData.selFontStyle">{{ formatData.reason }}</pre>
        </div>
      </div>
      <div class="rirekisho-pr-etc"
            v-if="formatId != 'rirekisho_kr_1'"
           :data-highlight="highlightMessage"
           @click="goCardTo('others')"
           :class="highLightClass('others')">
        <div class="time">
          <div class="label">통근시간</div>
          <div class="input"
               :class="{error: $formLib.charCount(formatData.commuteDescription) > this.textMaxLength['commuteDescription']}" :style="formatData.selFontStyle">{{ formatData.commuteDescription }}</div>
          <div class="input" v-if="formatData.commuteHours || formatData.commuteMinutes" :style="formatData.selFontStyle">약 <template v-if="formatData.commuteHours"><span>{{ formatData.commuteHours }}</span> 시간</template> <template v-if="formatData.commuteMinutes"><span>{{ formatData.commuteMinutes }}</span> 분</template></div>
        </div>
        <div class="family">
          <div class="label">부양가족 수(배우자 제외)</div>
          <div class="input"><span :style="formatData.selFontStyle">{{ formatData.spouseNumber }}</span> 명</div>
        </div>
        <div class="partner">
          <div class="existence">
            <div class="label">배우자</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked': formatData.hasSpouse}">유</span> ・
              <span class="no"
                    :class="{'preview-is-checked': !formatData.hasSpouse}">무</span></div>
          </div>
          <div class="support">
            <div class="label">배우자의 부양의무</div>
            <div class="input">
              <span class="yes"
                    :class="{'preview-is-checked':formatData.underDutyToSupport }">유</span> ・
              <span class="no"
                    :class="{'preview-is-checked':!formatData.underDutyToSupport }">무</span></div>

          </div>
        </div>
      </div>
    </div>
    <div class="rirekisho-hope"  style="height:268px;"
         :data-highlight="highlightMessage"
         @click="goCardTo('requests')"
         :class="highLightClass('requests')">
      <div class="label">본인희망란(급여·직종·근무시간·근무지·기타에 대해 희망이 있으면 기입)</div>
      <div class="input">
        <pre ref="request"
             :class="classObject.request" :style="formatData.selFontStyle">{{ formatData.request }}</pre>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import RirekishoPreviewMixin from '@/mixins/rirekisho-preview-mixin'
export default {
  name: 'rirekishoPreview',
  props: {
    formatId: {
      type: String
    }
  },
  mixins: [RirekishoPreviewMixin],
  data: function () {
    return {
      maxEduJobRows: 19,
      maxLicenseRows: 10,
      textareaMaxHeights: {
        reason: 240,
        request: 240
      }
    }
  },
  methods: {
    checkValid: function () {
      this.adjustFontSize('reason')
      this.adjustFontSize('reasonNew')
      this.adjustFontSize('request')
      this.adjustFontSize('addressFurigana')
    }
  },
  watch: {
    'formatData': function () {
      this.checkValid()
    }
  }
}
</script>
